
module.exports = function SortTriggersWidget ($host, config) {

  // Dom
  var $triggers = $('[data-sort-key]', $host);

  // Config
  var DIR_ASC = 0, DIR_DESC = 1;
  var sortClass    = 'is-sorting';
  var reverseClass = 'is-reversed';

  // State
  var state = {
    sortKey: '',
    direction: DIR_ASC
  };

  var callbacks = {
    update: id
  };

  // Functions
  function getSortKey (el) {
    return $(el).data('sort-key');
  }

  function proxyData (key, λ) {
    return function _proxyData (event) {
      λ($(this).data(key));
    };
  }

  function getTriggerFor (key) {
    return $triggers.filter(function () { return getSortKey(this) === key; });
  }

  function setActive (key) {
    $triggers.removeClass(sortClass);
    getTriggerFor(key).addClass(sortClass);
  }

  function setDirection (dir) {
    state.direction = dir;
    getTriggerFor(state.sortKey).toggleClass(reverseClass, dir === DIR_DESC);
  }

  function reverseDirection () {
    setDirection( state.direction === DIR_ASC ?  DIR_DESC : DIR_ASC );
  }

  function updatePrority (key) {
    setActive(key);

    if (state.sortKey === key) {
      reverseDirection();
    } else {
      setDirection(DIR_ASC);
      state.sortKey = key;
    }

    callbacks.update(state.sortKey, state.direction);
  }

  // Listeners
  $triggers.on('click', swallow(proxyData('sort-key', updatePrority)));

  // Init
  delay(0, function () {
    updatePrority('issue'); // Set default sort key
    updatePrority('issue'); // But in reverse order
  });

  // Interface
  return {
    onUpdate: function (λ) { callbacks.update = λ; }
  };

}

